<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td>Structure</td>
            <td>Material</td>
            <td style="text-align:right;padding-right:5px;">Capacity</td>
        </tr>
        <tr *ngFor="let s of storageStructures">
            <td>{{ s.storageStructureType }}</td>
            <td>{{ s.material }}</td>
            <td style="text-align:right;padding-right:5px;">
                {{ s.capacity | number }}<span *ngIf="s.capacity">&nbsp;{{ s.capacityUnit }}</span>
            </td>
        </tr>
    </table>
</div>

</ng-template>
    
    <ng-template #template_mobile let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td>Structure</td>
            <td>Material</td>
            <td style="text-align:right;padding-right:5px;">Capacity</td>
        </tr>
        <tr *ngFor="let s of storageStructures">
            <td>{{ s.storageStructureType }}</td>
            <td>{{ s.material }}</td>
            <td style="text-align:right;padding-right:5px;">
                {{ s.capacity | number }}<span *ngIf="s.capacity">&nbsp;{{ s.capacityUnit }}</span>
            </td>
        </tr>
    </table>
</div>

    </ng-template>